import { PermissionType } from '@/js/libs/generated/permissions/types.ts';
export const AGENCY_ROLES = [
    PermissionType.SELF_BOOKING,
    PermissionType.BOOK_CAMPAIGNS,
    PermissionType.MANAGE_ACCOUNTS,
    PermissionType.MANAGE_PRINT_CREATIVES,
    PermissionType.MANAGE_DIGITAL_CREATIVES,
];
export const YALEO_SELF_BOOKING_USER_ROLES = [
    PermissionType.YALEO_SELF_BOOKING,
    PermissionType.SELF_BOOKING,
    PermissionType.CREDIT_CARD_PAYMENT_ONLY,
    PermissionType.AGENCY,
    PermissionType.SWITCH_COMPANY_VIEW,
    // granting GenAI chat access must not flip a self-booking user out of their app mode
    PermissionType.GEN_AI,
];
/** Permissions that are excluded while assessing if a company is new. */
export const NEW_COMPANY_EXCLUDED_PERMISSIONS_SET = new Set([PermissionType.SWITCH_COMPANY_VIEW]);
